/**
 * Kenyan Banks List
 * Centralized list of Kenyan banks used across the application
 * for bank name selection in employee/teacher/advisor forms
 */
export const KENYAN_BANKS = [
  "Equity Bank",
  "Kenya Commercial Bank (KCB)",
  "Co-operative Bank of Kenya",
  "Standard Chartered Bank Kenya",
  "Absa Bank Kenya",
  "Diamond Trust Bank (DTB)",
  "National Bank of Kenya",
  "Bank of Africa Kenya",
  "I&M Bank",
  "NCBA Bank",
  "Family Bank",
  "Sidian Bank",
  "Consolidated Bank of Kenya",
  "Development Bank of Kenya",
  "Housing Finance Bank",
  "Prime Bank",
  "Stanbic Bank Kenya",
  "Guaranty Trust Bank (GTBank) Kenya",
  "Ecobank Kenya",
  "First Community Bank",
  "M Oriental Bank",
  "Paramount Bank",
  "UBA Kenya",
  "Victoria Commercial Bank",
];
